import { Loader2, Clock, XCircle } from "lucide-react";

// Voortgangsbalk + wachtrijpositie voor een lopende Monte Carlo-taak.
export default function McJobProgress({ t, job, queue, onCancel, cancelling }) {
  if (!job) return null;
  const queued = job.status === "queued";
  const pct = queued ? 0 : Math.max(0, Math.min(100, Number(job.progress) || 0));
  const ahead = queued && job.queue_position ? job.queue_position - 1 : 0;
  const label = queued
    ? (ahead > 0
        ? t("Positie {p} in de wachtrij · {n} simulatie(s) vóór jou").replace("{p}", job.queue_position).replace("{n}", ahead)
        : (queue?.running ? t("Volgende in de wachtrij — wacht tot de lopende simulatie klaar is") : t("In de wachtrij — start zo…")))
    : t("Simuleren… {pct}% van {n} runs").replace("{pct}", pct).replace("{n}", Number(job.n_runs || 0).toLocaleString("nl-NL"));

  return (
    <div className="border-2 border-foreground bg-card p-4 space-y-3" data-testid="mc-job-progress">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-sm font-display uppercase font-bold tracking-wide">
          {queued ? <Clock className="w-4 h-4 text-secondary" /> : <Loader2 className="w-4 h-4 animate-spin text-primary" />}
          <span data-testid="mc-job-status">{label}</span>
        </div>
        <button onClick={onCancel} disabled={cancelling} data-testid="mc-job-cancel"
                className="btn-brutal bg-background text-foreground px-3 py-1.5 font-display uppercase font-bold text-xs inline-flex items-center gap-1.5 disabled:opacity-50">
          <XCircle className="w-3.5 h-3.5" /> {t("Annuleren")}
        </button>
      </div>
      <div className="h-4 border-2 border-foreground bg-background relative overflow-hidden" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div className={`h-full transition-[width] duration-700 ease-out ${queued ? "bg-secondary/40 animate-pulse w-full" : "bg-primary"}`}
             style={queued ? undefined : { width: `${pct}%` }} data-testid="mc-job-bar" />
        {!queued && <span className="absolute inset-0 flex items-center justify-center text-[10px] font-mono-num font-bold mix-blend-difference text-white">{pct}%</span>}
      </div>
      <p className="text-[11px] text-muted-foreground">
        {t("De simulatie draait op de achtergrond — je kunt verder werken of naar een andere pagina gaan. Je krijgt een melding zodra het resultaat klaar is.")}
      </p>
    </div>
  );
}
